import {
	Box,
	Divider,
	Typography,
	Container,
	IconButton,
	Tooltip,
	FormControl,
	Button,
	useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddressCard from "../AddressCard/AddressCard";
import AddressDataForm from "../AddressDataForm";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./AddressShipping.css";
import { api } from "../../services/api";

function AddressShipping({
	userData,
	addresses,
	dataForm,
	handleChange,
	handleSubmit,
	handleLocalDelete,
	toggleEdit,
	states,
	edit,
}) {
	const navigate = useNavigate();
	const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

	const handleDelete = (addressId) => {
		Swal.fire({
			customClass: {
				confirmButton: "swalBtnOkCkout",
				cancelButton: "swalBtnCancelCkout",
				title: "swalTitleCkout",
				container: "swalTextSize",
			},
			position: "center",
			icon: "warning",
			title: "Eliminar dirección",
			text: `Estas seguro de eliminar esta dirección?`,
			width: "350px",
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: "De acuerdo",
			cancelButtonText: "Cancelar",
			focusConfirm: true,
			iconColor: "#e60b13",
			color: "#292929",
			background: "#FAFAFA",
			confirmButtonColor: "#292929",
			cancelButtonColor: "#FAFAFA",
		}).then((result) => {
			if (result.value) {
				api.account
					.deleteNewUserAddress(userData.userId, addressId)
					.then((res) => {
						if (res.status) handleLocalDelete(addressId);
					});
			}
			return;
		});
	};

	return (
		<Container className="infoContainer">
			{!edit ? (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					<AddressCard userAddress={userData} />
					{addresses?.length > 0 &&
						addresses?.map((address) => {
							return (
								<AddressCard
									userAddress={address}
									handleDelete={handleDelete}
									key={address.addressId}
								/>
							);
						})}
					<Button
						variant="contained"
						color="secondary"
						size={isSmallScreen ? "small" : "medium"}
						sx={{ marginTop: "2rem" }}
						onClick={() =>
							navigate("/user-account/address-shipping/new-address")
						}
					>
						Agregar dirección
					</Button>
				</Box>
			) : (
				<FormControl fullWidth onSubmit={handleSubmit}>
					<Box
						display="flex"
						justifyContent="space-between"
						alignItems="baseline"
					>
						<Box className="boxInfoContainer" my={1} pt={2}>
							<Typography className="titleFirstRow" sx={{ fontWeight: "600" }}>
								Dirección de envío
							</Typography>
						</Box>
						<Box>
							<Tooltip title="Cerrar">
								<IconButton
									size="large"
									aria-label="Cerrar edición de dirección"
									aria-controls="cierre-edición"
									aria-haspopup="false"
									color="inherit"
									onClick={toggleEdit}
								>
									<CloseIcon color="secondary" sx={{ fontSize: "1.5rem" }} />
								</IconButton>
							</Tooltip>
						</Box>
					</Box>
					<Divider />
					<AddressDataForm
						dataForm={dataForm}
						handleChange={handleChange}
						states={states}
					/>
					<Box sx={{ display: "flex", justifyContent: "center" }}>
						<Button
							id="btnForm"
							type="submit"
							color="brand"
							onClick={handleSubmit}
							variant="contained"
							sx={{
								width: "30%",
								minWidth: "150px",
								mt: 2,
								fontSize: "1rem",
								fontWeight: 700,
								textTransform: "none",
							}}
							style={{ fontFamily: "Quicksand" }}
						>
							Guardar
						</Button>
					</Box>
				</FormControl>
			)}
		</Container>
	);
}
export default AddressShipping;
